import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';


import { AuthenticationService } from '../shared/authentication.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService, private router: Router, private snackBar: MatSnackBar) { }
  intercept(request: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {


    const user = this.authService.USER;
    if (user) {
      request = request.clone({ setHeaders: { 'Token-X': user.token } });
    }
    
    return next.handle(request)
    .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
          }
        }, error => {
          if (error.status === 401) {
                   this.snackBar.open('Session expired... logging out', '', {duration:4000})
                   this.authService.logout();
                   this.router.navigate(['/login']);
                 }

        })
      );


  };

}
